import { LazyLoadResult, Ng2StateDeclaration, UIRouter } from '@uirouter/angular';
import { JourneyStates } from 'src/app/client/journey/router/journey-states';

export class AuthStateNames {
  static readonly Auth = 'auth';
  static readonly LoginDone = `${this.Auth}.loginDone`;
  static readonly LogoutDone = `${this.Auth}.logoutDone`;
  static readonly AuthRedirect = `${this.Auth}.redirect`;
}

const AuthState: Ng2StateDeclaration = {
  name: AuthStateNames.Auth,
  url: '/auth',
  loadComponent: () => import('../authentication.component').then(m => m.AuthenticationComponent),
  data: {
    allowAnonymous: true,
    data: { documentTitle: 'Client Journey' },
  },
};

const LoginDoneState: Ng2StateDeclaration = {
  name: AuthStateNames.LoginDone,
  url: '/loginDone?{returnUrl}',
  loadComponent: () => import('../login-done/login-done.component').then(m => m.LoginDoneComponent),
};

const LogoutDoneState: Ng2StateDeclaration = {
  name: AuthStateNames.LogoutDone,
  url: '/logoutDone?{returnUrl}',
  loadComponent: () => import('../logout-done/logout-done.component').then(m => m.LogoutDoneComponent),
};

const AuthRedirectState: Ng2StateDeclaration = {
  name: AuthStateNames.AuthRedirect,
  url: '/redirect',
  onEnter: async trans => {
    trans.abort();
    AuthStatesHelper.handleAuthRedirect(trans.router);
  },
  loadComponent: () => import('src/app/client/journey/error/error.component').then(m => m.ErrorComponent),
};

const AuthStates: Array<Ng2StateDeclaration> = [AuthState, LoginDoneState, LogoutDoneState, AuthRedirectState];

export const AuthStatesLazyLoaded: LazyLoadResult = {
  states: AuthStates,
};

export class AuthStatesHelper {
  private static readonly redirectUrlKey = 'returnUrl';
  private static readonly returnUrlExpireTimeKey = 'returnUrlExpireTime';

  static handleAuthRedirect(uiRouter: UIRouter) {
    const currentTime = new Date().getTime();
    const returnUrlExpireTime = Number(localStorage.getItem(this.returnUrlExpireTimeKey));
    const returnUrl = localStorage.getItem(this.redirectUrlKey);
    this.clearAuthRedirectUrl();

    if (currentTime < returnUrlExpireTime) {
      uiRouter.stateService.go(AuthStateNames.LoginDone, {
        returnUrl: returnUrl,
      });
    } else {
      JourneyStates.transitionToErrorState(uiRouter);
    }
  }

  static saveAuthRedirectUrl(redirectUrl: string, expiryTimeSpan: number) {
    //set login done url in local storage before initiating login
    localStorage.setItem(this.redirectUrlKey, redirectUrl);
    //set login done url expiry time to 5 days (as configured in auth0 password reset configuration)
    localStorage.setItem(this.returnUrlExpireTimeKey, (new Date().getTime() + expiryTimeSpan).toString());
  }

  static clearAuthRedirectUrl() {
    //set login done url in local storage before initiating login
    localStorage.removeItem(this.redirectUrlKey);
    //set login done url expiry time to 5 days (as configured in auth0 password reset configuration)
    localStorage.removeItem(this.returnUrlExpireTimeKey);
  }
}
